import { render, staticRenderFns } from "./OngoingItem.vue?vue&type=template&id=6c25285a&scoped=true&lang=pug&"
import script from "./OngoingItem.vue?vue&type=script&lang=js&"
export * from "./OngoingItem.vue?vue&type=script&lang=js&"
import style0 from "./OngoingItem.vue?vue&type=style&index=0&id=6c25285a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25285a",
  null
  
)

/* custom blocks */
import block0 from "./OngoingItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VDivider,VIcon,VImg,VSpacer})
